import { Div, DestroyingContentSwitcher, Ref, ComponentBase, Button } from "@tblabs/truffle";
import { RadioSwitchesBuilder } from "./RadioSwitchesBuilder";
import { Svg } from "./Svg";


export class Tabs extends Div
{
	protected switches = new RadioSwitchesBuilder(this.ref).Class("tabs-nav");
	protected content = new DestroyingContentSwitcher(this.ref);

	constructor(private ref = new Ref<string>(""))
	{
		super();

		this.Append(
			this.switches,
			this.content);
	}

	public Add(label: string, content: () => ComponentBase<any>): this
	{
		// this.switches.AddSwitch(label, new Button(label).Class("tab-button"), "uk-button-danger");
		this.switches.AddSwitch(label, new Button(label).Class("tab-button"), "tab-button-active");
		this.content.AddContent(label, content);

		return this;
	}
}

export class TabsV2 extends Div
{
	protected switches = new RadioSwitchesBuilder(this.ref).Class("tabs__list");
	protected content = new DestroyingContentSwitcher(this.ref).Class("tabs__content");

	constructor(private ref = new Ref<string>(""))
	{
		super("card");

		this.Append(
			new Div("tabs__nav").Append(this.switches),
			this.content,
		);
	}

	public Add(svgIcon: string, label: string, content: () => ComponentBase<any>): this
	{
		this.switches.AddSwitch(label,
			new Button(label)
				.Class("tabs__button")
				.Prepend(new Svg(svgIcon).Class("tabs__button-icon")),
			"tabs__button--active")

		this.content.AddContent(label, content);

		return this;
	}
}